import intl from "src/internationalization/intl"
import { Grid, LabelValue, Typography } from "../../basics"
import { BoxCard } from "../../basics/BoxCard"
import { CARD_WIDTH } from "../../../consts/cardSize"
import { ContextButton } from "../ContextButton"
import { IOverviewCardProps } from "./types"

const OverviewCard = (props: IOverviewCardProps) => {
    return (
        <BoxCard sx={{ width: CARD_WIDTH, maxWidth: CARD_WIDTH, p: 2 }}>
            <Grid container gap={1} justifyContent="space-between" alignItems="center" wrap="nowrap">
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                    {props.icon}
                    <Typography variant="h5" noWrap>
                        {props.title}
                    </Typography>
                </Grid>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    {props.headerAction}
                    {props.onClickAIButton && <ContextButton onClick={props.onClickAIButton} />}
                </Grid>
            </Grid>
            <Grid sx={{ mt: 1.5 }}>
                <LabelValue label={intl("impactedClients")} value={props.clientsNumber} />
                <LabelValue label={intl("totalAmount")} value={props.totalAmount} mt={1} />
            </Grid>
            {props.footer}
        </BoxCard>
    )
}

export { OverviewCard }

